var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlueLandscape(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 24,
    viewBox: "0 0 28 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 2H3C2.44772 2 2 2.44772 2 3V21C2 21.5523 2.44772 22 3 22H25C25.5523 22 26 21.5523 26 21V3C26 2.44772 25.5523 2 25 2Z",
    stroke: "#5D86DA",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 16.9998L8.29288 10.707C8.38573 10.6141 8.49597 10.5404 8.6173 10.4902C8.73862 10.4399 8.86866 10.4141 8.99998 10.4141C9.1313 10.4141 9.26134 10.4399 9.38267 10.4902C9.50399 10.5404 9.61423 10.6141 9.70709 10.707L15.2929 16.2927C15.3857 16.3856 15.496 16.4593 15.6173 16.5095C15.7386 16.5598 15.8687 16.5856 16 16.5856C16.1313 16.5856 16.2613 16.5598 16.3827 16.5095C16.504 16.4593 16.6142 16.3856 16.7071 16.2927L19.2929 13.707C19.3857 13.6141 19.496 13.5404 19.6173 13.4902C19.7386 13.4399 19.8687 13.4141 20 13.4141C20.1313 13.4141 20.2613 13.4399 20.3827 13.4902C20.504 13.5404 20.6142 13.6141 20.7071 13.707L26 18.9999",
    stroke: "#5D86DA",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 10C18.3284 10 19 9.32843 19 8.5C19 7.67157 18.3284 7 17.5 7C16.6716 7 16 7.67157 16 8.5C16 9.32843 16.6716 10 17.5 10Z",
    fill: "#5D86DA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueLandscape);
export default __webpack_public_path__ + "static/media/blue-landscape.21fe62f7.svg";
export { ForwardRef as ReactComponent };